'use client';

import Link from 'next/link';
import {setConsent} from '@/lib/consent';
import {useConsent} from '@/lib/useConsent';
import {buttonClass} from '@/components/Button';
import {track} from '@/lib/analytics';

const CookieBanner = () => {
  const consent = useConsent();
  if (consent !== 'unknown') {
    return null;
  }
  return (
    <section
      aria-label='Cookie-Einstellungen'
      className='fixed inset-x-4 bottom-4 z-50 rounded-2xl bg-white p-6 shadow-2xl ring-1 ring-zinc-200 sm:right-auto sm:left-6 sm:max-w-md'>
      <h2 className='font-semibold text-zinc-900'>Cookies & Statistik</h2>
      <p className='mt-2 text-sm leading-relaxed text-zinc-600'>
        Wir verwenden Cookies von Google Analytics, um anonyme Zugriffsstatistiken zu erstellen. Diese werden nur mit
        Ihrer Zustimmung gesetzt. Mehr dazu in der <Link href='/datenschutz/'>Datenschutzerklärung</Link>.
      </p>
      <div className='mt-5 flex gap-3'>
        <button type='button' className={`${buttonClass('secondary')} flex-1 cursor-pointer`} onClick={() => setConsent(false)}>
          Ablehnen
        </button>
        <button type='button' className={`${buttonClass('primary')} flex-1 cursor-pointer`} onClick={() => {
            setConsent(true);
            track('consent_update', {analytics_storage: 'granted'});
          }}>
          Akzeptieren
        </button>
      </div>
    </section>
  );
};

export default CookieBanner;
